import React, { useEffect, useState } from "react";

type Props = {
    isoCode: string;
    countryName: string;
    worldRef: React.RefObject<SVGSVGElement>
}

const CountryMapSvg: React.FC<Props> = ({ countryName, isoCode, worldRef }) => {
    const [paths, setPath] = useState<Element[]>([]);
    const [viewBox, setViewBox] = useState<string>(`0 0 0 0`);

    useEffect(() => {
        if (worldRef.current) {
            let paths = Array.from(worldRef.current.querySelectorAll('.' + isoCode));            
            setPath(paths);
        }
    }, [isoCode]);

    useEffect(() => {
        if (!!paths && paths.length > 0) {
            let bb = null
            if (paths.length > 1) {
                // Fare ciclo per vedere BB con valori più grandi
                bb = getTotalBB(paths);
            } else {
                // @ts-ignore
                bb = paths[0].getBBox();
            }

            setViewBox(`${bb.x} ${bb.y} ${bb.width} ${bb.height}`);
        }
    }, [paths]);

    const getTotalBB = (array: Element[]) => {
        // Get BB for all
        let bbs = array.map(el => {
            // @ts-ignore
            return el.getBBox();
        });

        let xMin = bbs[0].x;
        let xMax = bbs[0].x;
        let yMin = bbs[0].y;
        let yMax = bbs[0].y;
        let width = null;
        let height = null;
        bbs.forEach(bb => {
            // X
            if (bb.x < xMin) {
                xMin = bb.x;
            }

            if((bb.x + bb.width) >= xMax) {
                xMax = (bb.x + bb.width);
            }

            // Y
            if (bb.y < yMin) {
                yMin = bb.y;
            }
            if ((bb.y + bb.height) >= yMax) {
                yMax = (bb.y + bb.height);
            }
        });

        width = xMax - xMin;
        height = yMax - yMin;
        return { x: xMin, y: yMin, width, height }
    }

    return (
        <svg height={42} width={42} viewBox={viewBox}>
            {
                paths.map((p, index) => {
                    const d = p.getAttribute("d");
                    if (d) {
                        return (
                            <path className="fill-red" key={index} d={d}></path>
                        )
                    }
                })
            }
        </svg>
    )
}

export default React.memo(CountryMapSvg);